<template>
    <div class="fixed bottom-0 bg-[#4a4a4b] py-[20px] z-[66] w-full" v-if="status">
        <div class="container flex items-center">
            <div class="text-white pr-[80px]">
                <div class="font-bold text-[16px] mb-[4px]">{{ $t("CookiesTitle") }}</div>
                <span>
                    <i18n-t scope="global" keypath="CookiesContext">
                        <template v-slot:PrivacyPolicy
                            ><ProjectRoute
                                :to="{ name: 'Privacy' }"
                                class="text-white font-bold underline underline-offset-4 hover:text-[#9f50cb]"
                                target="_blank"
                                >{{ $t("PrivacyPolicy") }}</ProjectRoute
                            ></template
                        >
                        <template v-slot:UserAgreement
                            ><ProjectRoute
                                :to="{ name: 'Privacy' }"
                                class="text-white font-bold underline underline-offset-4 hover:text-[#9f50cb]"
                                target="_blank"
                                >{{ $t("UserAgreement") }}</ProjectRoute
                            ></template
                        >
                    </i18n-t></span
                >
            </div>
            <div class="shrink-0">
                <ui-button size="middle" :class="css_button.cancel" @click="confirm"
                    ><span class="font-bold text-emphas">{{ $t("EssentialOnly") }}</span></ui-button
                >
                <ui-button size="middle" class="ml-[16px]" @click="confirm"
                    ><span class="font-bold">{{ $t("AcceptAll") }}</span></ui-button
                >
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
//* 组件库
import { UiButton } from "various-ui";
//* 样式
import css_button from "@/assets/style/src/button.module.less";

//* 持久化属性
const status = useState("privacy_policy", () => false);

//* 隐私政策确认事件
const confirm = () => {
    localStorage.setItem("privacy_policy", "1");
    status.value = false;
};

//* 组件挂载时
onMounted(() => {
    //* 检测是否显示隐私政策
    status.value = !localStorage.getItem("privacy_policy");
});
</script>
